<template>
    <div>
        <OcorrenciaInfo :idOcorrencia="idOcorrencia" @setActionCard="setActionCard" :isFinalizado="ocorrencia.flFinalizado" />
        <section>
            <div class="container-fluid p-2">
                <div class="row">
                    <div class="col-12">
                        <div>
                            <div class="box-chat p-2">
                                <ul id="div_messages" class="div_messages" >
                                    <li class="d-flex mb-4" v-for="(message, index) in mensagens" :key="index">
                                        <div v-if="message.dsLoginConsultor" class="w-100 mt-2 col-12 row justify-content-end" style="margin-right: 10px; padding: 0;">
                                           
                                            <div class="d-flex justify-content-end">
                                                <div class="text-time mt-3" style="margin-right:10px;">{{ message.dtInclusao }}</div>
                                                <div class="text-title-chat  mt-3 " style="margin-right:10px;">{{ message.nmUsuario }}</div>
                                                <div v-html="svgGnp"></div>
                                            </div>

                                            <div class="d-flex mt-2" style="margin-right: -10px;">
                                                <div class="float-end ms-auto text-message-consultor">
                                                    {{ message.dsResposta }}
                                                </div>
                                            </div>

                                        </div>
                                        <div v-else class="w-100 mt-2 col-12 row justify-content-start" style="padding: 0;">
                                            <div class="d-flex ">
                                                <div class="d-flex justify-content-start">
                                                    <img src="../../../../assets/whatsapp/IconCliente.png" alt="avatar" class="rounded-circle shadow-1-strong chat-img-select" height="50" width="50" />
                                                </div>
                                                <div class="d-flex align-items-center">
                                                    <div class="d-flex">
                                                        <div class="text-title-chat" style="margin-left:10px;">{{ message.nmPessoa }}</div>
                                                        <div class="text-time" style="margin-left: 10px;">
                                                            {{ message.dtInclusao }}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="d-flex mt-2">
                                                <div class="float-end mr-auto text-message">
                                                    {{ message.dsResposta }}
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                                <div class="form-outline container-txt">
                                    <div>
                                        <input class="form-check-input" type="checkbox" id="exampleCheckbox" v-model="message_flSolicitarCliente">
                                        Solicitar informação ao cliente.
                                    </div>

                                    <div class="textarea-container mt-2">
                                        <textarea class="form-control text-size-12 area-message" rows="2" v-model="message_text" placeholder="Digite sua mensagem aqui..." @keyup.enter="sendMessage"></textarea>
                                        <label class="paper-plane-label">
                                            <i class="fas fa-paper-plane" @click="sendMessage"></i>
                                        </label>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>

    import $ from 'jquery';
    import axios from 'axios';
    import OcorrenciaInfo from '../../../../components/Tickets/Ocorrencia/Ocorrencia_Info.vue'

    export default {
        name: 'Mensagens do Chamado',
        components: {
            OcorrenciaInfo
        },
        props: {
            idOcorrencia: {
                type: Number,
                default: 0
            },
        },
        data() {
            return {
                mensagens: [],
                ocorrencia: {},
                svgGnp: `<svg width="50" height="50" viewBox="0 0 100 100" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <mask id="mask0_1910_102" style="mask-type:alpha" maskUnits="userSpaceOnUse"
                                    x="0" y="0" width="100" height="100">
                                    <circle cx="50" cy="50" r="50" fill="#9F3029" />
                                </mask>
                                <g mask="url(#mask0_1910_102)">
                                    <circle cx="50" cy="50" r="50" fill="#9F3029" />
                                    <path
                                        d="M37.9226 65.8692C38.8525 70.6691 43.0776 74.2933 48.1493 74.2933H69.4727C71.6096 74.2933 73.6448 73.8575 75.4941 73.0698C84.4978 80.4379 90.2444 91.6376 90.2444 104.179C90.2444 126.369 72.2561 144.358 50.0664 144.358C27.8766 144.358 9.88831 126.369 9.88831 104.179C9.88831 86.2224 21.6686 71.0168 37.9226 65.8692Z"
                                        fill="white" />
                                    <path
                                        d="M48.6461 17.4277C49.1059 17.3989 49.5696 17.3844 50.0367 17.3844C62.1685 17.3844 72.0032 27.2191 72.0032 39.3509C72.0032 45.7084 69.3025 51.4587 64.9857 55.4924H64.9091C63.1101 57.1541 61.0327 58.5189 58.7548 59.5087C57.3439 57.2076 54.8055 55.6725 51.9085 55.6725H48.1535C45.2499 55.6725 42.7065 57.2146 41.2976 59.5245C39.0054 58.5333 36.9155 57.1629 35.107 55.4924H35.0877C34.4246 54.8727 33.7995 54.2125 33.2166 53.5158C31.2782 51.2201 29.8021 48.5215 28.9318 45.5634V45.4704C28.3708 43.5256 28.0702 41.472 28.0702 39.3509C28.0702 37.2443 28.3667 35.2069 28.9204 33.2783C28.9188 33.2519 28.917 33.2256 28.915 33.1994C31.4542 24.4807 39.2523 18.0023 48.6461 17.4277Z"
                                        fill="white" />
                                    <path
                                        d="M50.4102 94.6675C49.2212 94.6675 48.0274 94.368 46.9335 93.7692C46.4293 93.4935 45.9204 93.2083 45.4162 92.9279C41.9062 90.965 38.5864 89.1114 34.691 88.6076L33.9871 88.5173V77.6714L34.9003 77.7903C39.1095 78.3368 42.7147 80.352 46.2058 82.3007C49.7158 84.2636 53.0356 86.1172 56.9357 86.621L57.6396 86.7113V87.4194C57.6396 90.0002 56.3127 92.3291 54.0868 93.6456C52.9405 94.3252 51.6754 94.6675 50.4102 94.6675ZM35.6042 87.1105C39.5138 87.7759 42.9145 89.677 46.2058 91.5163C46.7052 91.7968 47.2046 92.0772 47.7087 92.3528C49.4637 93.3129 51.5374 93.2796 53.2639 92.2625C54.7907 91.3595 55.7752 89.8434 55.9845 88.1181C52.0939 87.4432 48.7028 85.5516 45.421 83.717C42.1868 81.9109 39.119 80.1952 35.609 79.5393L35.5303 87.1105H35.6042Z"
                                        fill="#9F3029" />
                                    <path
                                        d="M56.8312 88.2274H56.0226V78.2275H66.0296V79.0355C66.0344 84.102 61.906 88.2274 56.8312 88.2274ZM57.6397 79.8435V86.5687C61.1783 86.1932 63.994 83.3748 64.3697 79.8435H57.6397Z"
                                        fill="#9F3029" />
                                    <path
                                        d="M26.4773 33.4982C26.4773 31.4247 24.7957 29.7432 22.7223 29.7432H20.8448C16.6968 29.7432 13.3349 33.1051 13.3349 37.2531V42.8856C13.3349 47.0336 16.6968 50.3955 20.8448 50.3955H22.7223C24.7957 50.3955 26.4773 48.714 26.4773 46.6405V33.4982ZM79.0467 50.3955C83.1948 50.3955 86.5566 47.0336 86.5566 42.8856V37.2531C86.5566 33.1051 83.1948 29.7432 79.0467 29.7432H77.1692C75.0958 29.7432 73.4143 31.4247 73.4143 33.4982V46.6405C73.4143 48.714 75.0958 50.3955 77.1692 50.3955H79.0467ZM49.9688 9.09091C33.2099 9.09091 20.4665 23.0347 19.9291 39.1306V41.0081C19.9291 42.0454 20.7693 42.8856 21.8066 42.8856H23.6841C24.7214 42.8856 25.5615 42.0454 25.5615 41.0081V39.1306C25.5615 25.6726 36.5108 14.7234 49.9688 14.7234C63.4268 14.7234 74.376 25.6726 74.376 39.1306H74.3619C74.3713 39.4157 74.376 58.5766 74.376 58.5766C74.376 61.3165 72.1547 63.5378 69.4148 63.5378H57.4787C57.4787 60.4271 54.957 57.9054 51.8463 57.9054H48.0913C44.9806 57.9054 42.4589 60.4271 42.4589 63.5378C42.4589 66.6486 44.9806 69.1703 48.0913 69.1703H69.4148C75.2655 69.1703 80.0085 64.4273 80.0085 58.5766V39.1306C79.471 23.0347 66.7276 9.09091 49.9688 9.09091Z"
                                        fill="white" />
                                </g>
                            </svg>` ,
                message_text: '',
                message_flSolicitarCliente: false
            }
        },
        mounted() { this.getOcorrencia(); },
        methods: {
            getOcorrencia() {
                let $this = this;

                axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/Ocorrencia/GetId?id=' + $this.idOcorrencia, {
                    headers: $this.$api.getTokenComercial(),
                    params: '',
                    notLoading: true
                }).then(response => {
                    $this.ocorrencia = response.data.data;
                    $this.getChamadoRespostas();
                })
            },
            getChamadoRespostas() {
                let $this = this;

                $this.mensagens = [];

                axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/ChamadoResposta/Get?idChamado=' + $this.ocorrencia.idChamado, {
                    headers: this.$api.getTokenComercial(),
                    params: '',
                }).then(response => {
                    $this.mensagens = response.data.data;

                    if ($this.mensagens.length > 0) {
                        $this.$nextTick(() => {
                            $('#div_messages').animate({ scrollTop: $('#div_messages')[0].scrollHeight }, 0);
                        });
                    }
                });
            },

            sendMessage() {
                let $this = this;

                var request = { idChamado: $this.ocorrencia.idChamado, dsResposta: $this.message_text, flSolicitaInfo: $this.message_flSolicitarCliente };

                axios.post(process.env.VUE_APP_ROOT_COMERCIAL_API + '/ChamadoResposta/Post', request, {
                    headers: this.$api.getTokenComercial()
                }).then(response => {
                    $this.getChamadoRespostas();
                    $this.message_text = '';
                    $this.message_flSolicitarCliente = false;
                    //$this.$emit('reloadGridOcorrencias');
                }).catch(function (error) {
                    var msg = 'Ocorreu um erro inesperado';
                    if (error.response) {
                        if (error.response.data.erros != '') {
                            msg = error.response.data.errors[0];
                        } else {
                            msg = error.response.data.msg;
                        }
                    }

                    $this.$toast.show('alert', msg, true);
                });
            },

            setActionCard(action) {
                this.$emit('setActionCard', action);
            },
        },
        watch: {
            //idOcorrencia(newVal, oldVal) {
            //    this.getOcorrenciaMensagens(newVal);
            //},
        },
    }

</script>

<style scoped lang="scss">
    section {
        font-family: 'Verdana';
        font-size: 14px;
        color: #434343;
    }

    .date-time {
        display: flex;
        flex-direction: column;
        line-height: 5px;
        padding-top: 8px;
    }

    @media screen and (max-width: 1000px) {
        .date-time {
            line-height: 25px;
            padding-left: 10px;
        }
    }

    .hidden {
        display: none;
    }

    .container-txt {
        position: relative;
    }

    .textarea-container {
        position: relative;

        textarea {
            width: 100%;
            // height: 200px;
        }
    }

    .file-upload-label {
        position: absolute;
        top: 10%;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 10px;
        background-color: transparent;
        cursor: pointer;
        color: #ACACAC;
        rotate: -42deg;
        font-size: 16px;

        i {
            margin-right: 5px;
            font-weight: 700;
        }
    }

    .paper-plane-label {
        position: absolute;
        top: 15%;
        right: 1%;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 10px;
        background-color: transparent;
        cursor: pointer;
        color: #ACACAC;
        font-size: 14px;

        i {
            margin-right: 5px;
            font-weight: 700;
        }
    }

    .id-person {
        .row.col-12 {
            position: fixed;
            height: 60px;
            width: 49.5%;
            background: #FFFFFF;
            margin-left: 0;


            .d-flex.justify-content-start.col-1 {
                padding: 5px 0 0 20px;
                // width: 75%;
            }

            .col-auto {
                display: flex;
                align-items: flex-end;
                font-style: normal;
                font-weight: 700;
                font-size: 16px;
                line-height: 28px;
                cursor: pointer;
            }
        }
    }

    .chat-tab {
        width: 80px;
    }

    .chat-hover {
        &:hover {
            background-color: #FFF5F5;
        }

        &.selected {
            margin-right: 0px;
            border-radius: 0 0 30px 0;
            box-shadow: 0px 5px 15px rgba(255, 0, 0, 0.5);

            .chat-img-select {
                width: 80px;
                height: 80px;
            }

            .chat-name-select {
                margin-left: 15px;
            }
        }
    }

    .chat-name-select {
        margin-left: 5px;
    }

    .fas.fa-info-circle {
        font-size: 32px;
        color: #631F1A;
    }

    .far.fa-calendar {
        font-size: 35px;
        color: #631F1A;
    }

    .far.fa-comment-alt {
        font-size: 35px;
        color: #631F1A;
    }

    ::-webkit-scrollbar {
        width: 10px;
    }

    ::-webkit-scrollbar-thumb {
        background: rgba(187, 187, 187, 0.5);
    }



    .text-size-12 {
        font-size: 12px;
    }

    .text-size-13 {
        font-size: 13px;
    }

    .text-size-14 {
        font-size: 14px;
    }

    .text-bold {
        font-style: normal;
        font-weight: 700;
    }

    .text-color-gnp-bold {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 700;
        font-size: 16px;
        color: #631F1A !important;
    }

    .text-color-gnp-bold-box-right {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 700;
        font-size: 14px;
        color: #631F1A !important;
    }

    .text-color-gnp {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        color: #631F1A !important;
    }

    .background-color-gnp {
        background-color: #9f3029 !important;
    }

    .list-unstyled {
        overflow-y: auto;
        min-height: calc(100vh - 7rem);
        max-height: calc(100vh - 7rem);
    }

    .box-chat {
        box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.25);
        border-radius: 5px;

        .linha-cinza {
            margin: 0;
        }
    }

    .box-chat-consultor {
        box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.25);
        border-radius: 5px 5px 50px 5px;
        background: #FFFFFF;
    }

    .remove-underline {
        text-decoration: none;
    }

    .border-bottom {
        border-bottom: 1.5px var(--bs-border-style, solid) #b7b7b7 !important;
    }

    .limit-text {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        width: 221px;
    }



    .div_messages {
        overflow-y: auto;
        min-height: calc(100vh - 25rem);
        max-height: calc(100vh - 25rem);
        padding-right: 5px;
        padding-top: 15px;
        padding-left: 15px;
    }


    .text-title-chat {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 700;
        font-size: 16px;
        color: #631F1A;
    }

    .text-message {
        background: #F7F2F2;
        color: #3F3F3F;
        padding: 8px;
        font-family: 'Inter';
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        border-radius: 0px 20px 20px 20px;
    }


    .text-message-consultor {
        background: #631F1A;
        color: #FFFFFF;
        padding: 8px;
        font-family: 'Inter';
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        border-radius: 20px 0px 20px 20px;
    }

    .text-time {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        color: #ACACAC;
        line-height: 24px;
    }

    .linha-cinza {
        margin-left: 8%;
        margin-right: 8%;
        background-color: #BBBBBB;
        border: 1px solid #BBBBBB;
    }

    .span-box-right {
        font-family: 'Inter';
        font-size: 12px;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

</style>